module.exports = __webpack_public_path__ + "img/quxiaojingyin.fw.3f55e470.png";